/**
 * clack renders every settled prompt and successful spinner stop with a green
 * `◇` (S_STEP_SUBMIT) and offers no settings hook to change it. Init wants
 * completed steps to read as successes — a green `✓`, matching the summary
 * checkmarks. This intercepts stdout writes and rewrites the exact styled
 * glyph sequence at submission; no cursor movement is ever involved, so the
 * check can never land on the wrong row.
 *
 * Only the colored sequence is matched: plain `◇` in content, uncolored
 * off-TTY output, and child processes with inherited stdio (which bypass
 * `process.stdout.write`) are all untouched.
 */
export const GREEN_STEP_SUBMIT = '\x1b[32m◇\x1b[39m'
export const GREEN_CHECK = '\x1b[32m✓\x1b[39m'
/**
 * clack@1.2.x's spinner erases the previous tick by measuring the bare
 * message, but each tick actually renders `frame + two spaces + message + up
 * to three animated dots`. When that rendered line wraps and the bare message
 * does not, the erase misses the first wrapped row and every tick prints a
 * stale copy of it. Rendered width overhead: 1 frame char + 2 spaces +
 * 3 dots, plus 1 column so the line never sits exactly on the terminal edge.
 */
export const RENDER_OVERHEAD = 7
export const MIN_MESSAGE_WIDTH = 8
/**
 * Rows a settled clack log/spinner line occupies on screen: the `│` guide row
 * clack prints above it plus the message row itself.
 */
export const CLACK_LINE_ROWS = 2
/** Rendered width of clack's log prefix: symbol + two spaces. */
export const LOG_PREFIX_WIDTH = 3
